import React from "react";
import { Box, Fade, IconButton } from "@mui/material";
import { X } from "lucide-react";

export const StreakModal = ({
  open,
  onClose,
  streak,
  isActive,
  isEmbedded,
}) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <Fade in={open} timeout={300}>
        <Box
          onClick={onClose}
          sx={{
            position: isEmbedded ? "fixed" : "absolute",
            inset: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        />
      </Fade>

      {/* Modal content */}
      <Fade in={open} timeout={300}>
        <Box
          maxWidth="xs"
          fullWidth
          sx={{
            position: isEmbedded ? "fixed" : "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "400px",
            bgcolor: "white",
            p: 4,
            outline: "none",
            textAlign: "left",
            overflow: "hidden",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
            border: "1px solid black",
            zIndex: 1000,
            borderRadius: "12px",
          }}
        >
          {/* Close button (X) */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "text.secondary",
            }}
          >
            <X size={24} />
          </IconButton>

          {/* Title with emoji */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
              gap: 1,
            }}
          >
            <span role="img" aria-label="fire" style={{ fontSize: "1.5rem" }}>
              🔥
            </span>
            <Box
              component="h2"
              sx={{
                fontWeight: 600,
                fontSize: "1.5rem",
                m: 0,
              }}
            >
              Daily Streak
            </Box>
          </Box>

          {/* Explanation text */}
          <Box>
            <Box
              component="p"
              sx={{
                mb: 2,
                lineHeight: 1.6,
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              Track consecutive days played:
              <Box
                component="span"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <span>•</span> Solve each day's puzzle
              </Box>
              <Box
                component="span"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <span>•</span> Use the same browser
              </Box>
              <Box
                component="span"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <span>•</span> Saves automatically - no login needed!
              </Box>
            </Box>
            <Box component="p" sx={{ mb: 2, lineHeight: 1.6 }}>
              Play daily to keep your streak alive!
            </Box>
          </Box>
        </Box>
      </Fade>
    </>
  );
};

const StreakCounter = ({
  streak,
  isActive = true,
  isFirstSolver = false,
  onClick,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        mx: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
          padding: "4px 8px",
          borderRadius: "12px",
          backgroundColor: isActive
            ? "rgba(0, 0, 0, 0.1)"
            : "rgba(128, 128, 128, 0.1)",
          color: isActive ? "#000000" : "rgba(0, 0, 0, 0.4)",
          fontSize: "0.875rem",
          fontWeight: "bold",
          opacity: isActive ? 1 : 0.5,
        }}
      >
        <span role="img" aria-label={isFirstSolver ? "trophy" : "fire"}>
          {isFirstSolver ? "🏆" : "🔥"}
        </span>
        {streak}
      </Box>
    </Box>
  );
};

export default StreakCounter;
